import React, { FC } from 'react';
import { useHistory } from 'react-router-dom';
import { formatCurrency } from '@factorin/util';

import { Button2, Button2Props } from 'Modules/ui3';
import { Wallet24 } from 'Modules/ui3/icons/Wallet24';


export interface Account {
    id: string;
    accountAmount: number;
}

export interface NominalAccountButtonProps extends Omit<Button2Props, 'children'> {
    url: string;
    external?: boolean;
    accounts?: Account[];
}

export const NominalAccountButton: FC<NominalAccountButtonProps> = ({
    url,
    external,
    accounts = [],
    sx,
    ...props
}) => {
    const history = useHistory();

    const buttonAmount = React.useMemo(() => {
        const total = accounts.reduce((sum, acc) => sum + acc.accountAmount, 0);
        return formatCurrency(total);
    }, [accounts]);

    const handleClick = () => {
        if (accounts[0]?.id) {
            const link = `${url}/${accounts[0].id}`;
            if (external)
                window.location.href = link;
            else
                history.push(link);
        }
    };

    return (
        <Button2
            variantType='main'
            variant='stroke'
            size='medium'
            startIcon={<Wallet24 />}
            onClick={handleClick}
            sx={[{
                px: 4,
                py: 1.5,
                fontSize: 14,
                lineHeight: '20px',
                fontWeight: 500,
                '& .MuiButton-startIcon > *:first-of-type': {
                    width: 16,
                    height: 16,
                },
            },
            ...Array.isArray(sx) ? sx : [sx]]}
            {...props}
        >
            {`${buttonAmount} ₽`}
        </Button2>
    );
};
